import axios from "axios";

const putConsultationReject = async (baseUrl, token, doctorId, consultationId,) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + "/doctor/" + doctorId + "/consult/" + consultationId + "/reject", {}, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return putResponse
}

export default putConsultationReject;